module.exports = __webpack_public_path__ + "media/images/homes/pos-linkedin-ec6b566b737bae9f7046ce6584d1bdac.png";